import Header from "../components/Header";
import api from "../components/api";
import { useEffect, useState } from "react";
import { Spinner, Badge, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const OrderCancelled = () => {
    const [loading, setLoading] = useState(true);
    const [orderCancelled, setOrderCancelled] = useState([]);

    useEffect(() => {
        api.get('order_cancelled')
            .then(response => {
                // On s'assure de récupérer un tableau, même si la réponse est vide
                setOrderCancelled(response.data.OrderCancelled || []);
            })
            .catch(error => {
                console.error('Erreur de récupération : ', error);
            })
            .finally(() => setLoading(false));
    }, []);

    // Filtrage pour n'afficher que les commandes ayant réellement le statut "Annulée"
    const cancelledList = orderCancelled.filter(order => order.status === 'Annulée');

    return (
        <>
            <Header />

            <div className="container mt-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className="fw-bold text-danger">
                        <FontAwesomeIcon icon={faBan} className="me-2" />
                        Commandes Annulées
                    </h1>
                    {!loading && (
                        <Badge bg="danger" pill className="px-3 py-2">
                            {cancelledList.length} Annulations
                        </Badge>
                    )}
                </div>

                {loading ? (
                    <div className="text-center mt-5">
                        <Spinner animation="border" variant="danger" />
                        <p className="mt-3 text-muted">Chargement du registre des annulations...</p>
                    </div>
                ) : (
                    <Card className="border-0 shadow-sm">
                        <div className="table-responsive" style={{ maxHeight: '500px' }}>
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-danger">
                                    <tr>
                                        <th className="ps-4">#</th>
                                        <th>Client</th>
                                        <th>Menu</th>
                                        <th>Date Commande</th>
                                        <th className="text-center">Qté</th>
                                        <th>Prix Perdu</th>
                                        <th>Localisation</th>
                                        <th className="text-center">Statut</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {cancelledList.length > 0 ? (
                                        cancelledList.map((order, orderIdx) => (
                                            order.order_items.map((item, itemIdx) => (
                                                <tr key={`${order.id}-${item.id}`}>
                                                    <td className="ps-4 text-muted fw-bold">
                                                        {itemIdx === 0 ? orderIdx + 1 : ""}
                                                    </td>
                                                    <td className="fw-semibold">
                                                        {itemIdx === 0 ? order.user?.name : ""}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-bold text-dark">{item.menu_item?.name}</span>
                                                            <small className="text-muted text-truncate" style={{maxWidth: '200px'}}>
                                                                {item.menu_item?.description}
                                                            </small>
                                                        </div>
                                                    </td>
                                                    <td className="small">
                                                        {itemIdx === 0 ? new Date(order.created_at).toLocaleString('fr-FR', {
                                                            day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
                                                        }) : ""}
                                                    </td>
                                                    <td className="text-center">{item.quantity}</td>
                                                    <td className="fw-bold text-danger">
                                                        {itemIdx === 0 ? `${order.total_price} FCFA` : ""}
                                                    </td>
                                                    <td>
                                                        {itemIdx === 0 && (
                                                            <span className="badge bg-light text-danger border border-danger-subtle">
                                                                {order.localisation}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {itemIdx === 0 && (
                                                            <span className="badge bg-danger uppercase">
                                                                {order.status}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center py-5 text-muted">
                                                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
                                                Aucune commande annulée dans les archives.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                )}
            </div>
        </>
    );
};

export default OrderCancelled;